import { render, staticRenderFns } from "./Oembed.vue?vue&type=template&id=4a78a1f5&"
import script from "./Oembed.vue?vue&type=script&lang=js&"
export * from "./Oembed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports